import { render, staticRenderFns } from "./ProfileImg.vue?vue&type=template&id=03cbffd8"
import script from "./ProfileImg.vue?vue&type=script&lang=js"
export * from "./ProfileImg.vue?vue&type=script&lang=js"
import style0 from "./ProfileImg.vue?vue&type=style&index=0&id=03cbffd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default})
